import { Button, Message, Modal } from '@mairistem/composants';
import { isEmpty } from 'lodash';
import React from 'react';
import type { DemandeCompte, JsonStatus } from '../../interfaces/demandeCompte';

interface DemandeCompteDetailModalProps {
	demandeCompte: DemandeCompte;
	onClose: () => void;
}

const DemandeCompteDetailModal = ({
	demandeCompte,
	onClose,
}: DemandeCompteDetailModalProps) => {
	const knownStatusKeys = [
		'anomalie',
		'pastell',
		'parapheur',
		'slow',
		'mailEnvoye',
		'userCim',
		'messagePublic',
		'messagePrive',
	];

	let jsonStatus: JsonStatus | null = null;
	let extraStatusKeys: [string, unknown][] = [];
	if (!isEmpty(demandeCompte.status)) {
		try {
			const parsed: Record<string, unknown> = JSON.parse(
				demandeCompte.status ?? '',
			);
			jsonStatus = parsed as unknown as JsonStatus;
			extraStatusKeys = Object.entries(parsed).filter(
				([key]) => !knownStatusKeys.includes(key),
			);
		} catch {
			jsonStatus = null;
		}
	}

	return (
		<Modal onClose={onClose} size="small" open>
			<Modal.Header>Détail de la demande de compte</Modal.Header>
			<Modal.Content>
				<div>
					<strong>Nom : </strong>
					{demandeCompte.nom || '-'}
				</div>
				<div>
					<strong>Prénom : </strong>
					{demandeCompte.prenom || '-'}
				</div>
				<div>
					<strong>Email : </strong>
					{demandeCompte.email || '-'}
				</div>
				<div>
					<strong>Qualité : </strong>
					{demandeCompte.qualite || '-'}
				</div>
				{demandeCompte.fonction && (
					<div>
						<strong>Fonction : </strong>
						{demandeCompte.fonction}
					</div>
				)}
				<div>
					<strong>Code client : </strong>
					{demandeCompte.codeClient || '-'}
				</div>
				{demandeCompte.siren && (
					<div>
						<strong>SIREN : </strong>
						{demandeCompte.siren}
					</div>
				)}
				<div>
					<strong>Code postal : </strong>
					{demandeCompte.codePostal || '-'}
				</div>
				<div>
					<strong>Ville : </strong>
					{demandeCompte.ville || '-'}
				</div>

				<div style={{ marginTop: '1em' }}>
					<strong>Date de la demande : </strong>
					{demandeCompte.date
						? new Date(demandeCompte.date).toLocaleDateString('fr-FR')
						: '-'}
				</div>
				<div>
					<strong>Date de traitement : </strong>
					{demandeCompte.dateTraitement
						? new Date(demandeCompte.dateTraitement).toLocaleDateString('fr-FR')
						: '-'}
				</div>
				<div>
					<strong>Statut : </strong>
					{!isEmpty(demandeCompte.statusCode)
						? demandeCompte.statusCode
						: 'Non traité'}
				</div>

				{jsonStatus && (
					<>
						{!isEmpty(jsonStatus.anomalie) && (
							<Message warning>
								<Message.Header>Anomalie</Message.Header>
								{jsonStatus.anomalie}
							</Message>
						)}
						{jsonStatus.pastell?.login && (
							<div>
								<strong>Login Pastell : </strong>
								{jsonStatus.pastell.login}
							</div>
						)}
						{jsonStatus.parapheur?.login && (
							<div>
								<strong>Login Parapheur : </strong>
								{jsonStatus.parapheur.login}
							</div>
						)}
						{jsonStatus.slow?.login && (
							<div>
								<strong>Login Slow : </strong>
								{jsonStatus.slow.login}
							</div>
						)}
						{jsonStatus.mailEnvoye && (
							<div>
								<strong>Mail envoyé : </strong>
								{jsonStatus.mailEnvoye}
							</div>
						)}
						{jsonStatus.userCim && (
							<div>
								<strong>Utilisateur CIM : </strong>
								{jsonStatus.userCim}
							</div>
						)}
						{jsonStatus.messagePublic && (
							<div>
								<strong>Message public : </strong>
								{jsonStatus.messagePublic}
							</div>
						)}
						{jsonStatus.messagePrive && (
							<div>
								<strong>Message privé : </strong>
								{jsonStatus.messagePrive}
							</div>
						)}
						{extraStatusKeys.map(([key, value]) => (
							<div key={key}>
								<strong>
									{key}
									{' : '}
								</strong>
								{typeof value === 'object'
									? JSON.stringify(value)
									: String(value)}
							</div>
						))}
					</>
				)}

				{demandeCompte.certificat && (
					<div style={{ marginTop: '1em' }}>
						<strong>Certificat : </strong>
						{demandeCompte.certificat}
					</div>
				)}
				{demandeCompte.certificatExpire && (
					<div>
						<strong>Expiration du certificat : </strong>
						{new Date(demandeCompte.certificatExpire).toLocaleDateString(
							'fr-FR',
						)}
					</div>
				)}

				{(demandeCompte.identifiantEntitePastell ||
					demandeCompte.identifiantUtilisateurPastell ||
					demandeCompte.loginUtilisateurPastell) && (
					<div style={{ marginTop: '1em' }}>
						{demandeCompte.identifiantEntitePastell && (
							<div>
								<strong>Identifiant entité Pastell : </strong>
								{demandeCompte.identifiantEntitePastell}
							</div>
						)}
						{demandeCompte.identifiantUtilisateurPastell && (
							<div>
								<strong>Identifiant utilisateur Pastell : </strong>
								{demandeCompte.identifiantUtilisateurPastell}
							</div>
						)}
						{demandeCompte.loginUtilisateurPastell && (
							<div>
								<strong>Login utilisateur Pastell : </strong>
								{demandeCompte.loginUtilisateurPastell}
							</div>
						)}
					</div>
				)}
			</Modal.Content>
			<Modal.Actions>
				<Button color="black" onClick={onClose}>
					Fermer
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default DemandeCompteDetailModal;
